import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { KeyUri } from '../key';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const Recommended = () => {
    const navigate = useNavigate();
    const [orders, setOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [selectedBooking, setSelectedBooking] = useState({
        route: null,
        date: new Date()
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const userid = localStorage.getItem("userID")?.replace(/"/g, "");

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (userid) {
                    const response = await axios.get(
                        `${KeyUri.BACKEND_URI}/get-bookings-user/${userid}`
                    );
                    setOrders(response?.data || []);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, [userid]);

    // Get unique routes
    const uniqueRoutesMap = new Map();
    orders.forEach(order => {
        if (order?.route?.name && !uniqueRoutesMap.has(order.route.name)) {
            uniqueRoutesMap.set(order.route.name, order);
        }
    });
    const uniqueRoutes = Array.from(uniqueRoutesMap.values());

    const handleDateSubmit = async () => {
        setIsSubmitting(true);
        try {

            const formattedDate = moment(selectedBooking.date).format('YYYY-MM-DD');
            const data = null;
            // data = localStorage.getItem('Selected Data'); 
            console.log("here is elected booking data",selectedBooking)
            const formData = {
                from: selectedBooking?.route?.route?.from_location?._id,
                to: selectedBooking?.route?.route?.to_location?._id,
                pickupStreet: selectedBooking?.route?.pickup_point,
                dropStreet: selectedBooking?.route?.drop_point,
                date: formattedDate,
                seats: selectedBooking?.route?.vehicleId?.category
            };

            console.log("Combined booking data:", formData);
            console.log("Formatted date:", formattedDate);
            await localStorage.setItem('Selected Data',JSON.stringify(formData));
            navigate("/sharedcabs");


            setShowModal(false);
            alert('Date saved successfully!');
        } catch (error) {
            console.error("Error storing booking:", error);
            alert('Error saving details. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="max-w-4xl mx-auto my-4 px-4 font-lato">
            {/* Modal */}
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-6 w-96">
                        <h2 className="text-xl font-semibold mb-4">
                            Select Travelling Date for {selectedBooking.route?.route?.name}
                        </h2>
                        <DatePicker
                            selected={selectedBooking.date}
                            onChange={(date) => setSelectedBooking(prev => ({
                                ...prev,
                                date: date
                            }))}
                            minDate={new Date()}
                            className="w-full p-2 border rounded mb-4"
                            dateFormat="dd/MM/yyyy"
                        />
                        <div className="flex justify-end gap-2">
                            <button
                                onClick={() => setShowModal(false)}
                                className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDateSubmit}
                                disabled={isSubmitting}
                                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-blue-300"
                            >
                                {isSubmitting ? 'Searching...' : 'Search Cabs'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Main Content */}
            <div className="bg-white rounded-3xl shadow-lg p-8 md:p-10 relative z-10">
                <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8 text-gray-800">
                    Previous Rides
                </h1>

                {isLoading ? (
                    <div className="text-center py-8">
                        <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-teal-500"></div>
                        <p className="mt-2 text-gray-500">Loading routes...</p>
                    </div>
                ) : uniqueRoutes.length > 0 ? (
                    <div className="flex flex-wrap gap-4 justify-center">
                        {uniqueRoutes.map((route, index) => (
                            <button
                                key={index}
                                className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-colors duration-200"
                                onClick={() => {
                                    setSelectedBooking({
                                        route: route,
                                        date: new Date()
                                    });
                                    setShowModal(true);
                                }}
                            >
                                {route.route?.name}
                            </button>
                        ))}
                    </div>
                ) : (
                    <div className="text-center py-8 text-gray-500">
                        Start your journey now
                    </div>
                )}
            </div>
        </div>
    );
};

export default Recommended;